import {request} from "../../../res/rest/restRequest";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {api} from "../../../res/rest/api";

const setCreditCardChargeRequest = async (session, orderID, surchargeRate, overpayment) => {

    const req = request.process("updatecreditcardsurcharge")
        .param("c_order_ID", orderID)
        .param("rate", surchargeRate)
        .param("overpayment", overpayment);

    console.log("in cc charge", session)

    const url = req.buildRequest(env.API_URL);
    console.log("throw error on proc error")
    return HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));
}

export default setCreditCardChargeRequest;